import {AxiosServer, ArrRemoveSubItem,AxiosEsb} from '../../utils';
import {message} from 'antd';
import {server} from '../../config/serverConfig';
let namespace = 'controlProductOrder_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const controlProductOrderAc ={
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},
	
	GET:(value)=>(dispatch,getState)=>{
		let store =getState().controlProductOrderRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize, order_type: "控货企信宝"}
		
		let Axios = AxiosServer();
		return Axios.post('/order/findAll',dataFetchProps).then((res)=>{	
						
			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('userlist ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})},	
	
	
	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错					
		value.id = parseInt(value.id);		
		let Axios = AxiosServer();
		return  Axios.post('/order/update',value).then((res)=>{	
			
		   dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});	
			
		//   dispatch(userlist_GET({order:[['id']]}));
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},	

	// 撤消订单
	CANCELORDER:(value = null)=>(dispatch,getState)=>{
		//可以多次dispatch(),  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//getState 可获取当前store的状态
		//强转id为数字，规免出错		
		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/cancelOrder',value).then((res)=>{
			console.log(res.data.status)
			if (res.data.status){
				return '更新成功'
			}else {
				return res.data.msg;
			}
		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})
	},	

	//导出excel文件
	GETXLS:()=>(dispatch,getState)=>{
		let store =getState().controlProductOrderRd;
		let {dataFetchProps,searchProps} =store;
		let props ={...dataFetchProps,...searchProps,pageSize: 5000, order_type: "控货企信宝"};
		let Axios = AxiosServer();
		return Axios.post('/api/excel/export/order',props).then((res)=>{			
			if (res.data.filename){				
				return (server.path+ res.data.filename);
			}else{
				return '下载失败';
			}
			
		}).catch((err)=>{
			message.error('错误:' + err.message,10);
			return '错误'
		})
	},	
}



export {controlProductOrderAc};